import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const NotFound = () => (
  <Box
    sx={{
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      gap: 2,
      px: 2,
    }}
  >
    <Typography variant="h2" component="h1" gutterBottom>
      404
    </Typography>
    <Typography variant="h5" gutterBottom>
      Sorry, the page you’re looking for doesn’t exist.
    </Typography>
    <Button
      variant="contained"
      component={RouterLink}
      to="/"
      size="large"
    >
      Go home
    </Button>
  </Box>
);

export default NotFound;
